import React from 'react';
import { Hero } from './components/sections/Hero';
import { Testimonials } from './components/sections/Testimonials';
import { PainPoints } from './components/sections/PainPoints';
import { Audience } from './components/sections/Audience';
import { SystemOverview } from './components/sections/SystemOverview';
import { Books } from './components/sections/Books';
import { Bonuses } from './components/sections/Bonuses';
import { Comparison } from './components/sections/Comparison';
import { Pricing } from './components/sections/Pricing';
import { ProFeatures } from './components/sections/ProFeatures';
import { Guarantee } from './components/sections/Guarantee';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { MetaPixel } from './components/utils/MetaPixel';
import { PurchasePopup } from './components/ui/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-[#FBF7F0] font-sans selection:bg-[#E76F51] selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Testimonials data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Audience data-id="element-6" />
        <SystemOverview data-id="element-7" />
        <Books data-id="element-8" />
        <Bonuses data-id="element-9" />
        <Comparison data-id="element-10" />
        <Pricing data-id="element-11" />
        <ProFeatures data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
      <PurchasePopup data-id="element-17" />
    </div>;
}